import { PlannedOccurrence, Task, Timestamp, WeekDays } from '@griply/types';
import { isBefore } from 'date-fns';

import { getTaskPlanning } from './get-task-planning';

export type GetEarliestUncompletedOccurrenceOptions = {
  startDate: Timestamp;
  endDate: Timestamp;
  today: Timestamp;
  weekStartsOn: WeekDays;
};

export const getEarliestUncompletedOccurrence = (
  task: Task,
  {
    startDate,
    endDate,
    today,
    weekStartsOn,
  }: GetEarliestUncompletedOccurrenceOptions,
): PlannedOccurrence | undefined =>
  getTaskPlanning(task, {
    startDate,
    endDate,
    today,
    weekStartsOn,
    uncompletedOnly: true,
  }).reduce<PlannedOccurrence | undefined>((earliest, occurrence) => {
    if (isBefore(occurrence.date, startDate)) {
      return earliest;
    }
    return !earliest || isBefore(occurrence.date, earliest.date)
      ? occurrence
      : earliest;
  }, undefined);
